var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeTabIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 23.2486H18.25C21 23.2486 23.25 20.9986 23.25 18.2486V10.1236C23.25 8.4986 22.5 7.12361 21.25 6.12361L15 1.37361C13.25 0.123605 10.75 0.123605 9 1.49861L2.75 6.12361C1.5 7.12361 0.75 8.4986 0.75 10.1236V18.2486C0.75 20.9986 3 23.2486 5.75 23.2486ZM3.25 10.1236C3.25 9.3736 3.625 8.6236 4.25 8.1236L10.5 3.37361C11 2.99861 11.5 2.87361 12 2.87361C12.5 2.87361 13 2.99861 13.5 3.37361L19.75 8.1236C20.375 8.6236 20.75 9.3736 20.75 10.1236V18.2486C20.75 19.6236 19.625 20.7486 18.25 20.7486H5.75C4.375 20.7486 3.25 19.6236 3.25 18.2486V10.1236Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeTabIconBlack);
export default __webpack_public_path__ + "static/media/home_tab_icon_black.f8390167caf2d569a83582b5c4d0c830.svg";
export { ForwardRef as ReactComponent };